module.exports = dormakaba.vendorTerrific['vendor/@gondel/core'];